// extracted by mini-css-extract-plugin
export default {"operatorActionConfigDialog":"operatorActionConfigDialog-trF6Z","title":"title-BCKOQ","configTab":"configTab-GYXrK"};